import React from 'react';
import { createTheme } from '@mui/material/styles';
import { grey, green, lightBlue, orange } from '@mui/material/colors';

export function ThemeSettings({ mode, fontSize, render }) {
	const theme = React.useMemo(
		() =>
			createTheme({
				typography: {
					fontSize: fontSize
				},
				palette: {
					mode,
					default: {
						main: grey[300],
						dark: grey[400]
					},
					textSecondary: {
						main: grey[300],
						dark: grey[400]
					},
					primary: {
						main: lightBlue[500]
					},
					secondary: {
						main: orange[500]
					},
					background: {
						default: '#ffffff'
					},
					action: {
						active: green[500],
						selected: '#4caf5033',
						hover: '#4caf5088'
					}
				}
			}),
		[mode, fontSize]
	);

	console.log('theme.typography.fontSize', theme.typography.fontSize);

	return render({ theme });
}
